import React, { useEffect, useRef } from 'react';

import { VisualStyleItem } from 'js/actionCreators/imageSearchActions';
import useOnClickOutside from 'js/shared/hooks/useOnClickOutside';
import useOnEscapeKey from 'js/shared/hooks/useOnEscapeKey';

import STYLE_ICONS from '../styleIcons';
import './StyleSelectorPanel.css';

interface StyleSelectorPanelProps {
  styles: VisualStyleItem[];
  onClose: () => void;
  onSelectStyle?: (style: VisualStyleItem) => void;
  selectedStyle?: string;
  buttonRef?: React.RefObject<HTMLButtonElement | null>;
}

const StyleSelectorPanel: React.FC<StyleSelectorPanelProps> = ({
  styles,
  selectedStyle,
  onClose,
  onSelectStyle = () => {},
  buttonRef
}) => {
  const panelRef = useRef<HTMLDivElement>(null);

  useOnClickOutside(buttonRef ? [panelRef, buttonRef] : panelRef, onClose);
  useOnEscapeKey(onClose);

  useEffect(() => {
    const selected = panelRef.current?.querySelector<HTMLButtonElement>('.StyleSelectorPanel__card--selected');
    selected?.focus();
  }, []);

  return (
    <div ref={panelRef} className="StyleSelectorPanel">
      <div className="StyleSelectorPanel__grid">
        {styles.map(style => (
          <button
            key={style.facetValue}
            className={`StyleSelectorPanel__card${selectedStyle === style.facetValue ? ' StyleSelectorPanel__card--selected' : ''}`}
            onClick={() => onSelectStyle(style)}
          >
            {STYLE_ICONS[style.iconKey] ? (
              <img
                src={STYLE_ICONS[style.iconKey]}
                alt={`Thumbnail representing the style ${style.label}`}
                className="StyleSelectorPanel__card-icon"
              />
            ) : (
              <div className="StyleSelectorPanel__card-icon" />
            )}
            <span className="StyleSelectorPanel__card-label">{style.label}</span>
            <span className="StyleSelectorPanel__card-description">{style.description}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default StyleSelectorPanel;
